import { render, staticRenderFns } from "./societyIndex.vue?vue&type=template&id=4f312fec&scoped=true"
import script from "./societyIndex.vue?vue&type=script&lang=js"
export * from "./societyIndex.vue?vue&type=script&lang=js"
import style0 from "./societyIndex.vue?vue&type=style&index=0&id=4f312fec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f312fec",
  null
  
)

export default component.exports